<template>
<div id="PasswordModel">
<b-modal id="modal-sml"  title="Update Password" v-model="showModal" no-close-on-esc no-close-on-backdrop hide-header-close>
  <div slot="default">
    <div class='alert alert-warning' role='alert' v-if=!succeeded> {{Msg}} <br> Please Contact System Administrator. </div>
    <div class="alert alert-success" role="alert" v-if=succeeded> {{Msg}} </div>
   </div> 
  <div slot="modal-footer" class="w-100">
        <p class="float-left" variant="primary"></p>
         <b-button variant="primary"  size="md"  class="float-right"  @click="passwordExit"> Close </b-button>
     </div>
</b-modal> 
   <div class="row">
   <p class="col-sm-12 my-2 pl-3 sml-red"><strong>Password Requirements:</strong> Minimum 12 characters. Passwords must use 3/4 available character types. Lowercase letters, Uppercase letters, Numbers and Symbols.</p>
  </div>
   
   <form>

    <div class="form-group row my-1"  v-show="showOldPassword">
    <label for="inputEmail3" class="col-sm-4 label-small">Old Password:</label>
    <div class="col-sm-4" :class="{ 'form-group--error': $v.oldPassword.$error}">      
      <input  type="password"  v-model.trim="$v.oldPassword.$model" placeholder="Password" class=" my-0 form-control form-control-xs">
    </div>
    <div  class="col-sm-4"  v-show="$v.oldPassword.$error || Msg !=''">
      <div class="row">
        <small class="sml-red" v-if="!$v.oldPassword.required && $v.oldPassword.$error&& !this.ExitBtnShow">Old password is required.</small>
        </div> 
    </div>
  </div>

   <div class="form-group row my-2 mt-2 mb-0">
    <label for="Password" class="col-sm-4 label-small my-0">New Password:</label>
    <div class="col-sm-4 my-0">
      <input id="Password" type="password"   v-model.trim="$v.newPassword.$model" placeholder="Password" class="mb-0 form-control form-control-xs">
    </div>
    <div class="col-sm-4 my-1"  v-show="$v.newPassword.$error" :class="{ 'col-sm-4 mb-0': $v.newPassword.$error}">
          <div class="row">
              <small class="sml-red" v-if="!$v.newPassword.required">Password is required.</small> 
          </div> 
           <div class="row">
              <small class="sml-red" v-if="!$v.newPassword.minLength">Minimum {{$v.newPassword.$params.minLength.min}} characters.</small>
          </div>
          <div class="row"> 
              <small class="sml-red" v-if="!$v.newPassword.PasswordCheck">Must meet the requirements.</small>
         </div>
           
          <div class="row">
            <small class="sml-red" v-if="!$v.newPassword.isNotSameAs">Password must not be the same as the current password.
             </small>
          </div>
          <div class="row">
            <small class="sml-red" v-if="!$v.newPassword.UserNameVerify">Password should not contain userid.
             </small>
          </div>
    </div>
  </div>

  <div class="form-group row my-1">
    <label for="CoPassword" class="col-sm-4 label-small">Confirm Password:</label>
    <div class="col-sm-4">      
      <input type="password"  v-model.trim="$v.confirmPassword.$model"  id="CoPassword" placeholder="Confirm Password" class=" my-0 form-control form-control-xs">
    </div>
    <div  :class="{ 'col-sm-4 mb-0': $v.confirmPassword.$error}"   v-show="$v.confirmPassword.$error">
      <div class="row">
        <small class="sml-red" v-if="!$v.confirmPassword.required">Confirm Password is required.</small>
        </div>
       <div class="row">
         <small class="sml-red" v-if="!$v.confirmPassword.sameAs">Must be the same as Password. 
           </small>
        </div> 
    </div>
  </div> 
  </form>  
  <hr>
  <div class="row">
    <div class="col-sm-6">
      <button v-bind:disabled="!showUpdate" v-on:click="updatePassword" type="button" class="btn BtnSave btn-sml"><i class="far fa-save"></i> Save Password</button>
    </div>
    <div class="col-sm-6 " v-if="ExitBtnShow">
        <button v-on:click="ClosePopup" type="button" class="btn BtnClose btn-sml float-right"><i class="fas fa-times"></i>Close Form</button>
    </div>
  </div>  
  
   </div>
</template>

<script>
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { helpers } from 'vuelidate/lib/validators';
import axios from 'axios';
import router from '@/router/AllRoutes';
const PasswordCheck = helpers.regex('alphaNum', /(?=.{0,})((?=.*\d)(?=.*[a-z])(?=.*[A-Z])|(?=.*\d)(?=.*[a-zA-Z])(?=.*[\W_])|(?=.*[a-z])(?=.*[A-Z])(?=.*[\W_])).*/)
Vue.use(Vuelidate)
import {required,minLength,sameAs, not} from 'vuelidate/lib/validators';
import { notEqual } from 'assert'; 
export default {
   props:{
     showExit:false,
     UpdatePasswordUser:'',
     ReturnURL:'' 
   },
  data(){
    return {
      userId:'',
      userName:'',
      userNameLabel:'',
      oldPassword:'',
      newPassword:'',
      confirmPassword:'',
      PWDminLength: 0,
     // showExit:false,
      Msg:'',
      showUpdate:true,
      showOldPassword:true,
      ExitBtnShow:false,
      UpdatedUser :'',
      showModal:false,
      succeeded:false
   }
  },
   methods: {
    updatePassword: function(){ 
      this.$v.$touch();
      var vm = this;
      if (!this.$v.$invalid || (!this.$v.newPassword.$error && !this.$v.confirmPassword.$error && (this.$v.oldPassword.$error && this.ExitBtnShow) )) {
         var params = new URLSearchParams();
         //////console.log(this.UpdatedUser);
          params.append("UserName", this.UpdatedUser);
           params.append("Password", this.oldPassword);
           params.append("NewPassword", this.newPassword);
           params.append("ConfirmPassword", this.confirmPassword);
          params.append("ClinicNo", 1);

             axios.get('SaskHealthApi/security/UpdatePassword', { headers: { 'Authorization': 'Bearer ' + this.$store.getters.GetAccessToken , 'Content-Type': 'application/x-www-form-urlencoded' },params})
            .then(response => {
             
                //vm.ExitBtnShow = true;
                vm.showUpdate = false;
                vm.Msg = "Password updated successfully";
                vm.succeeded=true;
                vm.showModal=true;
              })
            .catch(error=> {
              ////console.log(error)
                vm.Msg = error.data.message;
                 vm.succeeded=false;
                vm.showModal=true;
              });
      }
    },
    ClosePopup: function() {
       this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow');
    },
    UsernameExist : function()
    {
      
      var namefound = this.newPassword.toUpperCase().indexOf(this.UpdatedUser.toUpperCase()); 
      if(namefound == -1)
      return true;
      else
      return false;
       
    },
      passwordExit: function() {
        //this.ExitBtnShow=false;
        //this.UpdatedUser='';
        this.newPassword = '';
        this.confirmPassword = '';
        this.Msg = '';
        this.showUpdate = true;
        this.showModal=false;
        this.$v.$reset();
        if(this.succeeded){
          this.$root.$emit('bv::hide::modal', 'modal-1', '#btnShow')
          if(this.ReturnURL != "")
            router.push({path: this.ReturnURL});
        }
        // else if(!succeeded)
        // {
        //     this.showModal=false;
        // }

    }
      },

  mounted: function(){
    this.showOldPassword = !this.showExit;
    //this.ExitBtnShow = this.showExit
  },

  created: function() { 
    //////console.log('at created');
    this.ExitBtnShow = this.showExit;
    this.UpdatedUser =  this.UpdatePasswordUser;
    //////console.log( this.UpdatedUser);
      this.PWDminLength= this.$store.getters.GetPwdMinLength; 
        if(this.userId == ''){
          this.userIdLabel='Please update password'
        }
        else{
          this.userIdLabel= this.userId + ': Please update password.'
        }
  },
  validations(){
      return {
    oldPassword:{
      required
    },
    newPassword:{ 
      required,
      isNotSameAs:not(sameAs('oldPassword')),
      minLength: minLength(this.PWDminLength),
      PasswordCheck,
      UserNameVerify: value=> this.UsernameExist()
    },
    confirmPassword:{
      required,
      sameAs: sameAs('newPassword')
    }
  }
  }
}
</script>

<style scopeed>
.form-control-xs {
    height: calc(1.7em + .350rem + 1px) !important;
    padding: .150rem .25rem !important;
    font-size: .75rem !important;
    line-height: 1.5;
    border-radius: .2rem;
}
.label-small {
  vertical-align: super;
  font-size: small;
}

.modal-header {
    
    padding: .25rem !important;
    align-content: center;
    text-align: center !important;
}
/* .modal-footer
{
  padding: .50rem !important;
} */
.form-group {
  margin-bottom: 0;
}
</style>
